const ITEMS = [
  "Wholesale White Eggs",
  "Sold in Trays",
  "Fresh Daily Harvest",
  "Vikarabad, Telangana",
  "Direct Farm Supply",
  "Today's Rate on Request",
];

const Strip = ({ hidden }) => (
  <div aria-hidden={hidden} className="flex shrink-0 items-center">
    {ITEMS.map((t) => (
      <span
        key={t}
        className="flex items-center font-display text-sm uppercase tracking-[0.18em] text-[#6B1D2F] sm:text-base"
      >
        <span className="px-6">{t}</span>
        <span className="text-[#C5A059]">✦</span>
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div data-testid="marquee" className="overflow-hidden border-y border-[#E8DFC8] bg-[#F3EDE2] py-4">
    <div className="animate-marquee flex w-max">
      <Strip hidden={false} />
      <Strip hidden={true} />
    </div>
  </div>
);

export default Marquee;
